import React, { useState, useEffect } from 'react'
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Addsubcategory(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);
    const [subcategory, setsubcategory] = useState("");
    const [categoryId, setcategoryId] = useState("");
    const [addkey, setaddkey] = useState("");

    useEffect(() => {
      const getComments = async () => {
        try{
          const res = await fetch(`${apiUrl}/categorylist`,{
              method:'POST',
              headers:{
                  "Content-Type":"application/json",
                  "Accept":"application/json"
              },
          });
          const data = await res.json();
          if(data.status !== 200){
            throw new Error('Data not found');
          }
          setItems(data.catdata);
        }catch(error){
          console.error('Error ', error)
        }
      };
      getComments();
    }, []);

    const clicktoaddsubcategory = async (e) => {
        e.preventDefault();
        const postData = {
            subcategory_name: subcategory,
            cat_id: categoryId,
            keywords:addkey
        };
        const result = await fetch(`${apiUrl}/createsubcategory`,{
            method:'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(postData)
        });
        const data = await result.json();
        if((data.status === 200)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }else if((data.status === 400)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
        setsubcategory(' ');
        setaddkey(' ');
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Add Subcategory</h2> 
            <div className='commonCntr'>
                <form className="form-horizontal" onSubmit={clicktoaddsubcategory}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="subcategoryname">Subcategory Name:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="subcategoryname" onChange={(e)=>setsubcategory(e.target.value)} placeholder="Subcategory name" value={subcategory}/>
                        </div>
                    </div>
                    <div className="form-group mt-5">
                        <label className="control-label col-sm-2 label" htmlFor="categorytype">Category Type:</label>
                        <select class="form-select col-sm-5 selectBox" onChange={(e)=>setcategoryId(e.target.value)}>
                            <option value=''>Select Category Name</option>
                            {items.map((item , index) => {
                                return(<option value={item.id}>{item.category_name}</option>
                            )})}
                        </select>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="subcategorykeywords">Add Keywords:</label>
                        <div className="col-sm-4">
                            <input type="text" onChange={(e)=>setaddkey(e.target.value)} className="form-control" id="subcategorykeywords" placeholder="keyword1, keyword2" value={addkey}/>
                        </div>
                        <span className='d-block mt-2'>Keywords must be comma separated</span>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                    {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )}
            </div>
        </div>
    )
}

export default Addsubcategory;